import httpCommon from "../http-common";

class ApiServices {

    getHeaders = () => {
        let authHeader = {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`
            }
        }
        return authHeader;
    }

    login(loginRequest) {
        return httpCommon.post(`/auth/signin`, loginRequest);
    }
    
    addFirmware(type, version, mcuType, file, released, skipVersionValidation = false) {
        let URL = String(type) + "/" + String(version) + "/" + String(mcuType) + "/" + released;
        if (skipVersionValidation) URL += "?skip_version_validation=true";
        const header = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`
            }
        }
        let fd = new FormData();
        fd.append('file', file)
        return httpCommon.post(URL, fd, header);
    }

    deleteFirmware(type, version, mcuType) {
        let URL = String(type) + "/" + String(version) + "/" + String(mcuType)
        return httpCommon.delete(URL, this.getHeaders());
    }

    downloadFirmware(type, version, mcuType) {
        let URL = "/download/" + String(type) + "/" + String(version) + "/" + String(mcuType)
        const header = {
            headers: {         
                'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`
            },
            responseType: 'blob'
        }
        return httpCommon.get(URL, header);
    }
    
    searchFirmware(params) {
        const VALID_FIRMWARE_TYPES = new Set(["APP", "BL", "APP_V2", "APP_V3", "MESH1", "MESH2", "citycabinet::1.0", "citycabinet::2.0", "skyhub"]);
        let URL = "/search?"
        if (params) {
            if (VALID_FIRMWARE_TYPES.has(params.type)) {
                URL = String(URL) + "type=" + String(params.type)
            }
            if (params.version) {
                URL = String(URL) + "&version=" + String(params.version)
            }
            if (params.mcuType) {
                URL = String(URL) + "&mcutype=" + String(params.mcuType)
            } if (params.size) {
                URL = String(URL) + "&size=" + String(params.size)
            } if (params.page >= 0) {
                URL = String(URL) + "&page=" + String(params.page)
            }

        }
        return httpCommon.get(URL, this.getHeaders());
    }
    
    searchDevices(params,imei) {        
        const body ={
            deviceList: imei ? imei.split(',') : []
        }
        return httpCommon.post(`/device/search?${params}`,body,this.getHeaders());
    }

    getDevicesIMEIs(params,imei) {
        const body ={
            deviceList: imei ? imei.split(',') : []
        }
        return httpCommon.post(`/device/imeis?${params}`,body,this.getHeaders());
    }

    uploadDevices(file) {
        const header = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`
            }
        }
        let fd = new FormData();
        fd.append('file', file);
        return httpCommon.post(`/device/add`, fd, header);
    }

    fetchOTAHistoryOfDevice(imei) {
        return httpCommon.get(`/fota/attempted/${imei}`, this.getHeaders());
    }
    fetchLogOfDevice(imei){
        return httpCommon.get(`/fota/logs/${imei}`, this.getHeaders());
    }

    fetchVersionsFromType(type) {
        return httpCommon.get(`/${type}/versions`, this.getHeaders());
    }

    getUsers() {
        return httpCommon.get(`/user/all`, this.getHeaders());
    }

    registerUser(signupRequest) {
        return httpCommon.post(`/user/register`, signupRequest, this.getHeaders());
    }

    deleteUser(id) {
        return httpCommon.delete(`/user/${id}`, this.getHeaders());
    }

    getUser(id) {
        return httpCommon.get(`/user/${id}`, this.getHeaders());
    }

    updateUser(id, signupRequest) {
        return httpCommon.put(`/user/${id}`, signupRequest, this.getHeaders());
    }

    deleteFromOtaProcess(imei){
        return httpCommon.get(`/device/remove/${imei}`,this.getHeaders());
    }
    removeFromConfig(devicelist){
        const body ={
            deviceList:devicelist
        }
        return httpCommon.post(`/device/config/remove`,body,this.getHeaders());        
    }
    resetDeviceCounter(devicelist){    
        const body ={
            deviceList:devicelist
        }

        return httpCommon.post(`/device/config/resetcounter`,body,this.getHeaders());
    }
    addDeviceToOTA(reqBody){
        return httpCommon.post(`/device/config`,reqBody,this.getHeaders());
    }
    restartDevices(devicelist){
        const body ={
            deviceList:devicelist
        }
        return httpCommon.post(`/device/config/restart`,body,this.getHeaders());        
    }

    searchDeviceHardware(params,requestBody) {
        return httpCommon.post(`/device/hardware?${params}`,requestBody,this.getHeaders());
    }
    getMismatchedHardware(params) {
        return httpCommon.get(`/device/hardware-mismatch?${params}`,this.getHeaders());
    }
    flashHardwareId(requestBody){
        return httpCommon.post(`/device/flash-hardwareid`,requestBody,this.getHeaders());
    }       
    
    uploadHardwareIds(file) {
        let fd = new FormData();
        fd.append('file', file);

        const config = this.getHeaders();

        config.headers['content-type'] = 'multipart/form-data';

        return httpCommon.post(`/device/hardwareid`, fd, config);
    }

    // ── Gateway ────────────────────────────────────────────────────────────────

    getGateways(page = 0, size = 20, search = '', hasCabinet = null) {
        const q = search ? `&search=${encodeURIComponent(search)}` : '';
        const c = hasCabinet !== null ? `&hasCabinet=${hasCabinet}` : '';
        return httpCommon.get(`/gateway?page=${page}&size=${size}${q}${c}`, this.getHeaders());
    }

    getGateway(gatewayId) {
        return httpCommon.get(`/gateway/${gatewayId}`, this.getHeaders());
    }

    getGatewayDevices(gatewayId, page = 0, size = 20, macs = []) {
        const macsParam = macs.length > 0 ? `&${macs.map(m => `macs=${encodeURIComponent(m)}`).join('&')}` : '';
        return httpCommon.get(`/gateway/${gatewayId}/devices?page=${page}&size=${size}${macsParam}`, this.getHeaders());
    }

    startGatewayOta(payload) {
        return httpCommon.post(`/gateway/ota/start`, payload, this.getHeaders());
    }

    stopGatewayOta(payload) {
        return httpCommon.post(`/gateway/ota/stop`, payload, this.getHeaders());
    }

    getActiveOtaSessions() {
        return httpCommon.get(`/gateway/ota/active-sessions`, this.getHeaders());
    }

    getOtaSession(otaId) {
        return httpCommon.get(`/gateway/ota/session/${otaId}`, this.getHeaders());
    }

    getGatewayOtaSessions(gatewayId, page = 0, size = 20) {
        return httpCommon.get(`/gateway/${gatewayId}/ota/sessions?page=${page}&size=${size}`, this.getHeaders());
    }

    getActiveOtaSession(gatewayId) {
        return httpCommon.get(`/gateway/${gatewayId}/ota/active`, this.getHeaders());
    }

    searchFirmwareByMcuType(mcuType, type = null, page = 0, size = 50) {
        const typeParam = type ? `&type=${type}` : '';
        return httpCommon.get(`/search?mcutype=${mcuType}${typeParam}&page=${page}&size=${size}`, this.getHeaders());
    }

    searchFirmwareByGwType(binaryType, firmwareType, page = 0, size = 50) {
        return httpCommon.get(`/search?type=${firmwareType}&mcutype=${binaryType}&page=${page}&size=${size}`, this.getHeaders());
    }

    // ── GW Self-OTA (gateway chip firmware: ESP / CC / COO) ───────────────────

    startGwSelfOta(payload) {
        return httpCommon.post(`/gateway/gw-ota/start`, payload, this.getHeaders());
    }

    abortGwSelfOta(gatewayId, otaId) {
        return httpCommon.post(
            `/gateway/gw-ota/abort?gatewayId=${encodeURIComponent(gatewayId)}&otaId=${encodeURIComponent(otaId)}`,
            null,
            this.getHeaders()
        );
    }

    forceStopGwSelfOta(gatewayId, otaId) {
        return httpCommon.post(
            `/gateway/gw-ota/force-stop?gatewayId=${encodeURIComponent(gatewayId)}&otaId=${encodeURIComponent(otaId)}`,
            null,
            this.getHeaders()
        );
    }

    getGwSelfOtaSession(otaId) {
        return httpCommon.get(`/gateway/gw-ota/session/${encodeURIComponent(otaId)}`, this.getHeaders());
    }

    getGwSelfOtaSessions(gatewayId, page = 0, size = 20) {
        return httpCommon.get(`/gateway/${gatewayId}/gw-ota/sessions?page=${page}&size=${size}`, this.getHeaders());
    }

    getActiveGwSelfOtaSession(gatewayId) {
        return httpCommon.get(`/gateway/${gatewayId}/gw-ota/active`, this.getHeaders());
    }

    getActiveGwSelfOtaSessions() {
        return httpCommon.get(`/gateway/gw-ota/active-sessions`, this.getHeaders());
    }
}


export default new ApiServices();